import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import Landing from './Landing/Landing.js'
import DeliveryAddress from './DeliveryAddress/DeliveryAddress.js'
import DeliverySteps from './DeliverySteps/DeliverySteps.js'
import Shop from './Shop/Shop.js'
import NotFound from './../routers/NotFound.js';
import NotFoundShop from "../routers/NotFoundShop";

class App extends Component {
  render() {
    return (
      <Router>
        <div>
          {/*<Link to="/">Landing</Link>*/}
          {/*<Link to="/shop">Shop</Link>*/}
          {/*<Link to="&">Not found</Link>*/}

          <Switch>
            <Route exact path="/" component={Landing}/>
            <Route path="/shop" component={Shop}/>

            {/*  <Route path="/shop/not-found-shop" component={NotFoundShop} exact />*/}
            {/*  <Redirect from="*" to="/shop/not-found-shop" />*/}
            {/*</Route>*/}

            <Route path="/delivery-address" component={DeliveryAddress}/>
            <Route path="/delivery-order" component={DeliverySteps}/>

            <Route path="/404" component={NotFound} />
            <Redirect from="*" to="/404" />
          </Switch>

        </div>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js